import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form'

export class EditCustomersBulkModal extends React.Component {
  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false
  }

  handleChange(evt) {
    this.setState({ [evt.target.id]: evt.target.checked });
  }

  convertToArray() {
    let arr = [];
    if(this.state.monday) { arr.push("Monday") }
    if(this.state.tuesday) { arr.push("Tuesday") }
    if(this.state.wednesday) { arr.push("Wednesday") }
    if(this.state.thursday) { arr.push("Thursday") }
    if(this.state.friday) { arr.push("Friday") }
    if(this.state.saturday) { arr.push("Saturday") }
    if(this.state.sunday) { arr.push("Sunday") }
    return arr;
  }

  saveChanges = async () => {
    let days = this.convertToArray()
    let requestParams = {
      'customers': this.props.customers,
      'days': days
    }
    axios.post('/customers/deliverydays/bulk', requestParams)
          .then(data => {
            this.props.closeModal()
            toast.success('Delivery Days Saved')
          })
          .catch(err => {
            this.props.closeModal()
            console.error(err); 
            Rollbar.error(err)
            toast.error("Error: Could not save delivery days!");
          })
  }

  render() {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit ({this.props.customers.length}) Customers</h5>
            <button type="button" className="close" onClick={this.props.closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <h5>Delivery Days: </h5>
            <div>
              <Form.Check 
                custom
                type={'checkbox'}
                name={'monday'}
                id={'monday'}
                label={'Monday'}
                checked={this.state.monday}
                onChange={(e) => {this.handleChange(e)}}
              />
              <Form.Check 
                custom
                type={'checkbox'}
                name={'tuesday'}
                id={'tuesday'}
                label={'Tuesday'}
                checked={this.state.tuesday}
                onChange={(e) => {this.handleChange(e)}}
              />
              <Form.Check 
                custom
                type={'checkbox'}
                name={'wednesday'}
                id={'wednesday'}
                label={'Wednesday'}
                checked={this.state.wednesday}
                onChange={(e) => {this.handleChange(e)}}
              />
              <Form.Check 
                custom
                type={'checkbox'}
                name={'thursday'}
                id={'thursday'}
                label={'Thursday'}
                checked={this.state.thursday}
                onChange={(e) => {this.handleChange(e)}}
              />
              <Form.Check 
                custom
                type={'checkbox'}
                name={'friday'}
                id={'friday'}
                label={'Friday'}
                checked={this.state.friday}
                onChange={(e) => {this.handleChange(e)}}
              />
              <Form.Check 
                custom
                type={'checkbox'}
                name={'saturday'}
                id={'saturday'}
                label={'Saturday'}
                checked={this.state.saturday}
                onChange={(e) => {this.handleChange(e)}}
              />
              <Form.Check 
                custom
                type={'checkbox'}
                name={'sunday'}
                id={'sunday'}
                label={'Sunday'}
                checked={this.state.sunday}
                onChange={(e) => {this.handleChange(e)}}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Close</button>
            <button type="button" onClick={this.saveChanges} className="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    );
  }
}